export function getSnapshotFilename(value: string) {
  return `./__snapshots__/${value}.output.html`;
}

// Function expects any parameter
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounceCallback<T extends (...args: any[]) => void>(func: T, delay: number) {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
}
